export const apiURL = {
    main: "https://beda.isgood.host/api",
}
